const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4946,-1087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9",
    transform: "matrix(1,0,0,1,4946.2,1087.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(37,159,103)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.939622,0,0,0.939622,32.5335,42.4809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.547,406.398C447.026,550.36 469.156,725.661 486.532,905.06C488.303,922.618 503.002,936.031 520.648,936.192C538.294,936.353 553.236,923.211 555.328,905.688C575.563,739.756 600.276,581.238 625.574,439.766C623.247,440.011 620.89,440.118 618.508,440.118C598.752,440.118 580.703,432.748 566.985,420.591C553.336,502.709 534.923,626.451 522.845,790.053C520.254,656.077 501.465,529.552 487.446,435.95L486.238,435.996C460.404,435.996 437.228,424.529 421.547,406.398Z",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7304,0,0,0.7304,137.042,3.40533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.9,281.255C358.745,202.767 433.684,146.522 521.656,146.522C593.955,146.522 657.451,184.511 693.21,241.619C760.547,241.955 815.105,296.728 815.105,364.143C815.105,376.804 813.181,389.019 809.607,400.513C826,413.99 836.458,434.419 836.458,457.271C836.458,497.81 803.546,530.723 763.006,530.723C753.941,530.723 745.258,529.078 737.243,526.058C724.361,555.74 694.779,576.513 660.383,576.513C631.337,576.513 605.723,561.699 590.701,539.218C573.245,545.57 554.676,549.579 535.368,550.817C519.353,563.349 499.189,570.807 477.296,570.807C432.807,570.807 395.454,540.008 385.438,498.577L383.281,496.521C369.572,509.552 351.036,517.54 330.649,517.54C288.406,517.54 254.109,483.243 254.109,440.999C254.109,412.426 269.8,387.488 293.043,374.356C283.696,364.485 277.994,351.155 277.994,336.504C277.994,306.77 301.48,282.479 330.9,281.255Z",
    style: {
      fill: "white"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.cd15029bf1165f2558f0c25dd0faecdf.svg";
export { ForwardRef as ReactComponent };